module.exports = __webpack_public_path__ + "media/images/pic/courses/group-banner-49a5483a23129c017b2774aa33fee7d0.webp";